import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';

const { coreappIpc } = window;

const AccountLocked = createModal(({ open, parentEmail }: { open: boolean; parentEmail: string }) => {
    const { t } = useTranslation('access-restricted');
    const [seconds, setSeconds] = useState(30);

    const restart = () => {
        coreappIpc.send('restart');
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            if (seconds > 0) setSeconds(seconds - 1);
            else restart();
        }, 1000);
        return () => clearTimeout(timer);
    });

    return (
        <Modal show={open} backdrop="static" centered>
            <section className="notificationPopup layerSty launcherUpdateDlg">
                <h1>{t('header')}</h1>
                <div className="container">
                    <div className="stit">
                        <h2>
                            <i className="icon-warning" />
                            &nbsp;&nbsp;<span>{t('title')}</span>
                        </h2>
                    </div>
                    <div className="cnts">
                        <p>{t('desc')}</p>
                        <br />
                        <br />
                        <div>{parentEmail}</div>
                        <br />
                        <br />
                        <p>{t('dialog:logout-count', { seconds })}</p>
                    </div>
                    <div className="bt">
                        <button type="button" className="button3" onClick={() => restart()}>
                            <span>{t('dialog:restart-now')}</span>
                        </button>
                    </div>
                </div>
            </section>
        </Modal>
    );
});

export default AccountLocked;
